// @ts-check
import { Image } from '@react-pdf/renderer';
import { Box, Page, Text, Title } from '../../../pdf-design-system';
import VieVinumLine from '../components/VieVinumLine';
import { Separator } from './VieVinumMyList';
import { theme } from './VieVinumMyListTable';
import React from 'react';

export default function VieVinumMyListRearCover() {
  return (
    <Page size="A4" theme={theme}>
      <A5Box>
        {/* 300dpi */}
        <Image src="https://res.cloudinary.com/bottlebooks/image/upload/w_2126,f_auto,q_auto/vievinum/parterre.png" />
      </A5Box>
      <Separator />
      <A5Box>
        <Image src="https://res.cloudinary.com/bottlebooks/image/upload/w_2126,f_auto,q_auto/vievinum/mezzanin.png" />
      </A5Box>
      <VieVinumFooter
        fixed
        style={[
          { position: 'absolute', bottom: '7mm', left: '15mm', right: '15mm' },
        ]}
      />
      <React.Fragment />
    </Page>
  );
}

function A5Box({ children, ...rest }) {
  return (
    <Box
      style={{
        display: 'flex',
        paddingHorizontal: '15mm',
        paddingTop: '10mm',
        paddingBottom: '10mm',
        height: '148.5mm',
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

function VieVinumFooter({ style, ...rest }) {
  return (
    <Box
      style={[
        { display: 'flex', flexDirection: 'row', alignItems: 'flex-end' },
        style,
      ]}
      {...rest}
    >
      <Image
        src="https://res.cloudinary.com/bottlebooks/image/upload/c_fill,h_170,q_auto,w_240/vievinum/vievinum.jpg"
        style={{ width: '10mm', marginVertical: '-0.3mm' }}
      />
      <VieVinumLine style={{ width: '169mm', marginLeft: '1mm' }} />
    </Box>
  );
}
